import { render, staticRenderFns } from "./pageCategories.vue?vue&type=template&id=3f91f0ba&"
import script from "./pageCategories.vue?vue&type=script&lang=js&"
export * from "./pageCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports